import styled from "styled-components";
import media from "cssMix/index";

export const MainContainer = styled.div`
  width: 100%;
  padding: 70px 50px 0px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  background: url("images/bg.png"), #12110f;
  background-size: 100%;
  background-repeat: no-repeat;
  overflow-y: overlay;
  position: relative;
  ${media.tablet`
  min-height:100vh;
  overflow: inherit;
  background-image: linear-gradient(to right, #161826, #1e1738 100%);
  border-radius: ${(props) =>
    props.mainAreaRoute === "Favorite" || props.mainAreaRoute === "Recent"
      ? `0`
      : `40px 40px 0 0`};
  padding: ${(props) => (props.mainAreaRoute !== "Lobby" ? `0` : `30px 0 0`)};
  & > div{
    box-sizing:border-box;
    padding: 0 16px; 
  }
  `}
`;

export const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.div`
  box-sizing: border-box;
  flex-grow: 1;
  flex-basis: 100%;
  position: relative;
  & .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    & .info {
      font-size: 23px;
      color: #f9be00;
      cursor: pointer;
    }
  }
  & .rank-container {
    display: flex;
    justify-content: space-between;

    & > div {
      width: ${(props) =>
        `calc(${100 / props.column}% - ${
          (10 * (props.column - 1)) / props.column
        }px)`};
      max-width: ${(props) => `${1450 / props.column - 10}px`};
      ${media.tablet`
        width: ${(props) => `${(100 - (props.column - 1)) / props.column}%`}
      `}
    }
  }
  & .title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }
  ${media.tablet`
    height:100%;
    width:100%;
    ${(props) =>
      (props.mainAreaRoute === "PayoutRank" ||
        props.mainAreaRoute === "PlayerRank") &&
      `overflow:overlay;`}
    & .title{
      font-size: 18px;
      margin: 0;
    margin: 24px 0;

    }
    & .rank-container {
      padding:30px 0 0;
    }
    & .title-container {
      position:fixed;
      top:30px;
      width:calc(100% - 32px);
      margin-bottom:16px;
    }
    `}
  ${media.mobile`

        `}
`;

export const RankMainContainer = styled(MainContainer)`
  ${media.tablet`
  overflow:overlay;
  padding: 0 0 100px;
`}
`;

export const RankMain = styled(Main)`
  overflow: overlay;
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  @media (min-width: 1025px) {
    margin-top: 102px;
    .title-container {
      position: fixed;
      top: 70px;
      width: calc(100% - 360px);
      max-width: 1440px;
    }
    .rank-container {
      padding-top: 70px;
    }
  }
`;
